/** @format */

var Store = {
  init: config => {
    Store.Shared.Page.template = config.template;
    Store.Shopify.token = config.shopifyStoreFrontToken;
    Store.Searchanise.apiKey = config.searchaniseApiKey;
    Store.Modal.init();
    Store.Header.Navigation.init();
    Store.Footer.initAccordion();
    Store.Translations = config.translations;
    if (Store.Shared.Page.template == 'product') Store.PDP.init();
    if (Store.Shared.Page.template == 'collectiob') Store.Searchanise.filters.init();
    Store.backToTop();
    Store.Emitter.init();
    setTimeout(() => {
      Store.PDP.tabs();
    }, 2000);

    document.querySelectorAll('form').forEach(formElem => {
      formElem.addEventListener('invalid', invalidFormHandler, true);
      formElem.addEventListener('input', formInputHandler);
    });
  },

  Translations: [],
  Shared: {
    Cart: {},
    Product: {},
    Modal: {},
    Tooltip: {},
    Page: {}, //{template:string,...}
  },
  Emitter: {
    types: {
      document_scroll: 'document.scroll',
      document_click: 'document.click',
      window_resize: 'window.resize',
      added_to_cart: 'added_to_cart',
      pdp_tab_click: 'pdp.tab_click',
    },
    init: () => {
      document.addEventListener('scroll', e => {
        Store.Emitter.emit(Store.Emitter.types.document_scroll);
      });

      document.addEventListener('click', e => {
        Store.Emitter.emit(Store.Emitter.types.document_click, e);
      });

      window.addEventListener('resize', () => {
        Store.Header.Navigation.init();
        Store.PDP.tabs();
        Store.PDP.renderFAQPanel();
        Store.Emitter.emit(Store.Emitter.types.window_resize);
      });

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', function () {
          Store.PDP.tabs();
        });
      }
    },
    events: {},
    tokenize: (len = 23) => {
      const rand = () => Math.random(0).toString(36).substr(2);
      const token = length => (rand() + rand() + rand() + rand()).substr(0, length);
      return token(len);
    },
    subscribe: (eventName, listener) => {
      const events = Store.Emitter.events;
      const token = Store.Emitter.tokenize();
      if (!events[eventName] || events[eventName].length < 1) events[eventName] = [];
      events[eventName].push({token, listener});
      return token;
    },
    unsubscribe: token => {
      const events = Store.Emitter.events;
      Object.keys(events).forEach(key => {
        const subscriber = events[key].findIndex(obj => obj.token === token);
        if (subscriber !== -1) {
          events[key].splice(subscriber, 1);
        }
      });
    },
    getListener: eventName => {
      return Store.Emitter.events[eventName];
    },
    emit: (eventName, params) => {
      const events = Store.Emitter.events;
      if (!events[eventName] || events[eventName].length < 1) return;
      events[eventName].forEach(function ({token, listener}) {
        listener(!!params ? params : {});
      });
    },
  },
  Sliders: [],
  Factory: {
    productSlider: selector => {
      return Store.Factory.customSlider(selector, {
        slidesPerGroup: 1,
        speed: 300,
        longSwipes: true,
        longSwipesMs: 300,
        longSwipesRatio: 0.5,
        followFinger: true,
        allowTouchMove: true,
        resistance: true,
        resistanceRatio: 0.85,
        threshold: 20,
        touchRatio: 1,
        touchReleaseOnEdges: true,
        breakpoints: {
          0: {
            spaceBetween: 16,
            slidesPerView: 1.5,
          },
          320: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 1.8,
          },
          460: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 2,
          },
          640: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 2.5,
          },
          768: {
            slidesOffsetBefore: 16,
            spaceBetween: 24,
            slidesPerView: 3.25,
          },
          968: {
            slidesOffsetBefore: 8,
            spaceBetween: 24,
            slidesPerView: 4,
          },
          1280: {
            slidesOffsetBefore: 0,
            spaceBetween: 24,
            slidesPerView: 4,
          },
        },
      });
    },
    categorySlider: selector => {
      return Store.Factory.customSlider(selector, {
        slidesPerGroup: 1,
        speed: 300,
        longSwipes: true,
        longSwipesMs: 300,
        longSwipesRatio: 0.5,
        followFinger: true,
        allowTouchMove: true,
        resistance: true,
        resistanceRatio: 0.85,
        threshold: 20,
        touchRatio: 1,
        touchReleaseOnEdges: true,
        breakpoints: {
          0: {
            spaceBetween: 16,
            slidesPerView: 1.5,
          },
          320: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 1.8,
          },
          460: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 2,
          },
          640: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 2.5,
          },
          768: {
            slidesOffsetBefore: 16,
            spaceBetween: 24,
            slidesPerView: 3.25,
          },
          968: {
            slidesOffsetBefore: 8,
            spaceBetween: 24,
            slidesPerView: 4,
          },
          1280: {
            slidesOffsetBefore: 0,
            spaceBetween: 24,
            slidesPerView: 4,
          },
        },
      });
    },
    cardSlider: selector => {
      return Store.Factory.customSlider(selector);
    },
    recipeSlider: selector => {
      return Store.Factory.customSlider(selector, {
        slidesPerGroup: 1,
        speed: 300,
        longSwipes: true,
        longSwipesMs: 300,
        longSwipesRatio: 0.5,
        followFinger: true,
        allowTouchMove: true,
        resistance: true,
        resistanceRatio: 0.85,
        threshold: 20,
        touchRatio: 1,
        touchReleaseOnEdges: true,
        breakpoints: {
          0: {
            spaceBetween: 16,
            slidesPerView: 1.25,
          },
          320: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 1.5,
          },
          460: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 2,
          },
          640: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 2.5,
          },
          768: {
            slidesOffsetBefore: 16,
            spaceBetween: 24,
            slidesPerView: 3.25,
          },
          968: {
            slidesOffsetBefore: 8,
            spaceBetween: 24,
            slidesPerView: 4,
          },
          1280: {
            slidesOffsetBefore: 0,
            spaceBetween: 24,
            slidesPerView: 4,
          },
        },
      });
    },
    blogSlider: selector => {
      return Store.Factory.customSlider(selector, {
        slidesPerGroup: 1,
        speed: 300,
        longSwipes: true,
        longSwipesMs: 300,
        longSwipesRatio: 0.5,
        followFinger: true,
        allowTouchMove: true,
        resistance: true,
        resistanceRatio: 0.85,
        threshold: 20,
        touchRatio: 1,
        touchReleaseOnEdges: true,
        breakpoints: {
          0: {
            spaceBetween: 16,
            slidesPerView: 1.25,
          },
          320: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 1.5,
          },
          460: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 2,
          },
          640: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 2.5,
          },
          768: {
            slidesOffsetBefore: 16,
            spaceBetween: 24,
            slidesPerView: 3.25,
          },
          968: {
            slidesOffsetBefore: 8,
            spaceBetween: 24,
            slidesPerView: 4,
          },
          1280: {
            slidesOffsetBefore: 0,
            spaceBetween: 24,
            slidesPerView: 4,
          },
        },
      });
    },
    bundleSlider: selector => {
      return Store.Factory.customSlider(selector, {
        breakpoints: {
          0: {
            spaceBetween: 12,
            slidesPerView: 2.5,
            slidesPerGroup: 2,
          },
          1024: {slidesPerView: 6},
        },
      });
    },
    recentlySlider: selector => {
      return Store.Factory.customSlider(selector, {
        slidesPerGroup: 1,
        speed: 300,
        longSwipes: true,
        longSwipesMs: 300,
        longSwipesRatio: 0.5,
        followFinger: true,
        allowTouchMove: true,
        resistance: true,
        resistanceRatio: 0.85,
        threshold: 20,
        touchRatio: 1,
        touchReleaseOnEdges: true,
        breakpoints: {
          0: {
            spaceBetween: 16,
            slidesPerView: 2.25,
          },
          320: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 2.5,
          },
          460: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 3,
          },
          640: {
            slidesOffsetBefore: 24,
            spaceBetween: 16,
            slidesPerView: 3.5,
          },
          768: {
            slidesOffsetBefore: 16,
            spaceBetween: 24,
            slidesPerView: 4.25,
          },
          968: {
            slidesOffsetBefore: 8,
            spaceBetween: 24,
            slidesPerView: 5,
          },
          1280: {
            slidesOffsetBefore: 0,
            spaceBetween: 24,
            slidesPerView: 6,
          },
        },
      });
    },
    flavourSlider: selector => {
      return Store.Factory.customSlider(selector, {
        enabled: true,
        slidesPerGroup: 1,
        speed: 300,
        longSwipes: true,
        longSwipesMs: 300,
        longSwipesRatio: 0.5,
        followFinger: true,
        allowTouchMove: true,
        resistance: true,
        resistanceRatio: 0.85,
        threshold: 20,
        touchRatio: 1,
        touchReleaseOnEdges: true,
        breakpoints: {
          0: {
            slidesOffsetBefore: 24,
            spaceBetween: 12,
            slidesPerView: 3.75,
            enabled: true,
          },
          320: {
            slidesOffsetBefore: 24,
            spaceBetween: 12,
            slidesPerView: 4.5,
            enabled: true,
          },
          480: {
            slidesOffsetBefore: 24,
            spaceBetween: 12,
            slidesPerView: 5.5,
            enabled: true,
          },
          620: {
            slidesOffsetBefore: 24,
            spaceBetween: 12,
            slidesPerView: 7.5,
            enabled: true,
          },
          768: {
            slidesPerView: 'auto',
            spaceBetween: 'auto',
            enabled: false,
          },
        },
      });
    },
    productBenefitsSlider: selector => {
      return Store.Factory.customSlider(selector, {
        breakpoints: {
          0: {
            spaceBetween: 12,
            slidesPerView: 1.6,
            slidesPerGroup: 1,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
        on: {
          init: function() {
            // Force parent container to recalculate height
            const tab = document.querySelector('nav.tabs > ul > li.active');
            if (tab) {
              const content = tab.querySelector('.tab-content-container');
              if (content) {
                setTimeout(() => {
                  tab.style.height = content.scrollHeight + 100 + 'px';
                }, 100);
              }
            }
          }
        }
      });
    },
    pageCarousel: selector => {
      return Store.Factory.customSlider(selector, {
        breakpoints: {
          0: {
            spaceBetween: 16,
            slidesPerView: 1.2,
            slidesPerGroup: 1,
            slidesOffsetAfter: 48,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
            slidesPerGroup: 1,
          },
        },
      });
    },
    pageFeaturesPanel: selector => {
      return Store.Factory.customSlider(selector, {
        breakpoints: {
          0: {
            spaceBetween: 16,
            slidesPerView: 1.4,
            slidesPerGroup: 1,
            slidesOffsetAfter: 48,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
            slidesPerGroup: 1,
          },
        },
        scrollbar: {
          el: `${selector} .swiper-scrollbar`,
        },
      });
    },
    uspSLider: selector => {
      return Store.Factory.customSlider(selector, {
        autoplay: {
          delay: 14000,
        },
        loop: true,
        enabled: true,
        breakpoints: {
          0: {
            direction: 'vertical',
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          1024: {
            direction: 'horizontal',
            slidesPerView: 5,
            enabled: false,
          },
        },
      });
    },
    heroBannerSlider: selector => {
      return Store.Factory.customSlider(selector, {
        pagination: {
          el: `${selector} .swiper-hero-pagination`,
          type: 'bullets',
          bulletClass: 'hero-pagination-bullet',
          bulletActiveClass: 'active-hero-pagination-bullet',
          clickable: true,
        },

        autoplay: {
          delay: 5000,
          pauseOnMouseEnter: true,
        },
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        breakpoints: {
          0: {
            navigation: false,
          },
          976: {
            navigation: {
              nextEl: `${selector} .swiper-button-next-hero`,
              prevEl: `${selector} .swiper-button-prev-hero`,
            },
          },
        },
      });
    },
    customSlider: (selector, options) => {
      const defaults = {
        slidesPerView: 4,
        maxMobileSlides: 2,
        spaceBetween: 24,
        slidesPerGroup: 2,
        speed: 500,
        preventInteractionOnTransition: true,
        navigation: {
          nextEl: `${selector} .swiper-button-next`,
          prevEl: `${selector} .swiper-button-prev`,
        },
        //simulateTouch: true,
        breakpoints: {
          0: {
            spaceBetween: 16,
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          320: {
            spaceBetween: 16,
            slidesPerView: 2,
            slidesPerGroup: 1,
          },
          640: {
            spaceBetween: 16,
            slidesPerView: 3,
            slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
        pagination: false,
        on: {
          slideChangeTransitionStart(swiper) {
            swiper.el.classList.add('swiper-scrolling');
          },
          slideChangeTransitionEnd(swiper) {
            swiper.el.classList.remove('swiper-scrolling');
          },
        },
      };
      const slider = new Swiper(selector, {...defaults, ...options});
      Store.Sliders.push(slider);
      return slider;
    },
  },
  //isMobile: () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768,
  isMobile: () => window.innerWidth <= 768,
  Searchanise: {
    apiKey: '',
    getCollection: async (handle, startIndex, maxResults, sortBy, sortOrder, filters, initialLoad) => {
      let facets = {};
      for (const [category, values] of Object.entries(filters)) {
        facets[`${category.replace('rb_', '')}`] = values.join('|');
      }

      const url = new URL('https://searchserverapi.com/getresults');

      const params = new URLSearchParams({
        apiKey: Store.Searchanise.apiKey,
        startIndex,
        maxResults,
        sortBy,
        sortOrder,
        items: true,
        pages: true,
        categories: true,
        suggestions: true,
        queryCorrection: true,
        facets: true,
        facetsShowUnavailableOptions: true,
      });

      params.append(Store.Collection.handle == 'search' ? 'q' : 'collection', Store.Collection.query);

      for (const [category, values] of Object.entries(filters)) {
        params.append(`restrictBy[${category.replace('rb_', '')}]`, values.join('|'));
      }

      url.search = params.toString();

      if (initialLoad) {
        Store.Collection.createFacetsLoader();
        Store.Collection.createProductsSkeleton();
      } else {
        Store.Collection.createProductsSkeleton();
      }

      const response = await fetch(url.href);
      return await response.json();
    },
    filters: {
      init: () => {
        const sortOptions = document.querySelectorAll('.sorting .dropdown-options > li');
        sortOptions.forEach(option => {
          option.addEventListener('click', () => {
            sortOptions.forEach(o => o.classList.remove('active'));
            option.classList.toggle('active');
          });
        });
      },
      toggleDropdown: id => {
        var dropdown = document.querySelector(`[data-id=${id}]`);
        const isOpen = dropdown && dropdown.classList.contains('on');
        const selectedItemsLabel = dropdown && dropdown.querySelector('.selected-items');

        document.querySelectorAll('.dropdown.on').forEach(dd => {
          dd.classList.remove('on');
          dd.dataset.token && Store.Emitter.unsubscribe(dd.dataset.token);
          selectedItemsLabel && selectedItemsLabel.classList.remove('hidden');
        });

        if (!isOpen && dropdown) {
          dropdown.classList.add('on');
          selectedItemsLabel && selectedItemsLabel.classList.add('hidden');
          const token = Store.Emitter.subscribe(Store.Emitter.types.document_click, e => {
            if (!dropdown.contains(e.target)) {
              dropdown.classList.remove('on');
              Store.Emitter.unsubscribe(token);
              selectedItemsLabel && selectedItemsLabel.classList.remove('hidden');
            }
          });
          Store.Collection.currentlyOpenDropdownId = id;
        } else {
          Store.Collection.currentlyOpenDropdownId = null;
        }
        return isOpen;
      },
      toggleCheckbox: (category, item) => {
        var selector = '[data-category="' + category + '"][data-id="' + item + '"]';
        var element = document.querySelector(selector);
        element.classList.toggle('active');
      },
      toggleFilters: () => {
        window.scrollTo(0, 0);
        document.querySelector('.filter-dropdown-mobile').classList.toggle('on');
      },
    },
  },
  Shopify: {
    token: '',
    productQueryTemplate: function (index, handle) {
      return `_${index}:product(handle:"${handle}"){title onlineStoreUrl images(first:1){edges{node{url(transform:{maxWidth: 90, maxHeight: 90})}}}}`;
    },
    getProducts: function (handles) {
      var token = Store.Shopify.token;
      var queryTemplate = Store.Shopify.productQueryTemplate;
      return new Promise(function (resolve, reject) {
        var query = [];
        for (var i = 0, x = handles.length; i < x; i++) {
          query.push(queryTemplate(i, handles[i]));
        }
        var request = new XMLHttpRequest();
        request.open('POST', '/api/graphql', true);
        request.setRequestHeader('Content-Type', 'application/graphql');
        request.setRequestHeader('X-Shopify-Storefront-Access-Token', token);
        request.onreadystatechange = function () {
          if (this.readyState == XMLHttpRequest.DONE && this.status == 200) {
            var jsonResponse = JSON.parse(request.responseText);
            resolve(jsonResponse);
          }
        };
        request.send(`{${query.join('')}}`);
      });
    },
  },
  Header: {
    elements: {
      navigation: null,
      hamburger: document.querySelector('#header-hamburger'),
      close: document.querySelector('#header-close'),
      membership: document.querySelector('#header-membership'),
      cart: document.querySelector('#header-cart'),
      logo: document.querySelector('#header-logo'),
    },
    Navigation: {
      isMobileNavigation: () => (document.querySelector('#header-navigation-mobile') ? true : false),
      init: () => {
        Store.Header.elements = {
          navigation:
            document.querySelector('#header-navigation-desktop') || document.querySelector('#header-navigation-mobile'),
          hamburger: document.querySelector('#header-hamburger'),
          close: document.querySelector('#header-close'),
          membership: document.querySelector('#header-membership'),
          cart: document.querySelector('#header-cart'),
          logo: document.querySelector('#header-logo'),
        };

        if (!Store.isMobile() && Store.Header.Navigation.isMobileNavigation()) {
          const navigation = document.querySelector('.header-navigation-mobile');
          if (!navigation) return;
          navigation.classList.add('header-navigation-desktop');
          navigation.classList.remove('header-navigation-mobile');
          navigation.id = 'header-navigation-desktop';

          const menuItems = document.querySelectorAll('.header-navigation-menu');
          menuItems.forEach(item => {
            item.classList.remove('!hidden', 'active');
          });

          const menu = document.querySelector('.header-navigation-desktop > ul');
          menu?.classList.remove('!-left-full', 'opacity-0');

          Store.Header.Navigation.init();
        } else if (Store.isMobile() && !Store.Header.Navigation.isMobileNavigation()) {
          const navigation = document.querySelector('.header-navigation-desktop');
          if (!navigation) return;
          navigation.classList.add('header-navigation-mobile');
          navigation.classList.remove('header-navigation-desktop');
          navigation.id = 'header-navigation-mobile';
          Store.Header.Navigation.init();
        }

        //Desktop
        const headerNavDesktop = document.querySelector('#header-navigation-desktop');
        const navContainerDesktop = document.querySelector('#header-navigation-container');
        const navItemsDesktop = document.querySelectorAll('#header-navigation-desktop > ul > li');
        const navItemsMobile = document.querySelectorAll('#header-navigation-mobile > ul > li');
        const navMenuTitle = document.querySelector('.header-navigation-menu-title');
        const navSubItemsMobile = document.querySelectorAll(
          '#header-navigation-mobile > .header-navigation-container .header-navigation-menu li:first-child'
        );
        const navSubItemsMobileButtonLinks = document.querySelectorAll(
          '#header-navigation-mobile > .header-navigation-container .header-navigation-menu li:not(:first-child) button[data-href]'
        );
        const navSubItemsDesktopButtonLinks = document.querySelectorAll(
          '#header-navigation-desktop > .header-navigation-container .header-navigation-menu li:not(:first-child) button[data-href]'
        );

        headerNavDesktop?.addEventListener('mouseenter', Store.Header.Navigation.expandContainer);
        headerNavDesktop?.addEventListener('mouseleave', Store.Header.Navigation.collapseContainer);

        navItemsDesktop.forEach(item => {
          item.addEventListener('mouseenter', e => {
            e.stopImmediatePropagation();
            const activeMenu = document.querySelector('.header-navigation-menu.active');
            activeMenu && activeMenu.classList.remove('active');
            const activeNav = document.querySelector('#header-navigation-desktop > ul > li.active');
            activeNav && activeNav.classList.remove('active');
            item.classList.add('active');
            const {navigation} = item.dataset;
            const menu = document.querySelector(`[data-menu='${navigation}']`);
            menu?.classList.add('active');

            if (!menu) {
              Store.Header.Navigation.collapseContainer();
              item.classList.add('active');
              return;
            }

            navContainerDesktop.style.height = `${menu.scrollHeight + 48}px`;
          });
        });

        const buttonLinkListener = item => {
          item.addEventListener('click', e => {
            if (e.currentTarget.dataset.href) {
              location.href = e.currentTarget.dataset.href;
            }
          });
        };

        navSubItemsDesktopButtonLinks.forEach(buttonLinkListener);

        //Mobile
        navItemsMobile.forEach(item => {
          item.addEventListener('click', e => {
            const {navigation, navigation_link} = item.dataset;
            const menu = document.querySelector(`[data-menu='${navigation}']`);
            if (!menu) {
              return true;
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            // document.querySelector('body')?.classList.add('fixed');
            item.parentElement?.classList.add('!-left-full', 'opacity-0');
            navItemsMobile.forEach(item => item.classList.remove('active'));
            item.classList.add('active');

            const mobileItemMenu = navMenuTitle.querySelector('.item-link');
            mobileItemMenu.textContent = item.textContent;

            mobileItemMenu.addEventListener('click', e => {
              location.href = navigation_link;
            });

            const menuItems = document.querySelectorAll('.header-navigation-menu');
            menuItems.forEach(item => {
              item.classList.add('!hidden');
              item.classList.remove('active');
            });
            menu?.classList.remove('!hidden');
            menu?.classList.add('active');
          });
        });

        navSubItemsMobile.forEach(item => {
          item.addEventListener('click', e => {
            e.preventDefault();
            e.stopImmediatePropagation();
            const currentActiveItem = document.querySelector('.header-navigation-menu ul.active li:first-child');

            if (currentActiveItem) {
              const currentActiveMenu = currentActiveItem.parentElement;
              currentActiveMenu.style.height = '';
              currentActiveMenu.classList.remove('active');
              setTimeout(() => {
                currentActiveMenu.querySelector('.show-more')?.classList.remove('!hidden');
              }, 500);

              const currentActiveItemIcons = currentActiveItem.querySelectorAll('img');
              currentActiveItemIcons.forEach(icon => {
                icon.classList.toggle('!hidden');
              });

              if (item === currentActiveItem) return;
            }

            const icons = item.querySelectorAll('img');
            icons.forEach(icon => {
              icon.classList.toggle('!hidden');
            });

            const activeMenu = item.parentElement;

            activeMenu.classList.add('active');
            const subItems = activeMenu.querySelectorAll('li');
            //TODO: Calculate 403px dynamically
            const parentHeight = subItems?.length > 6 ? `403px` : `${activeMenu.scrollHeight}px`;
            activeMenu.style.height = `${parentHeight}`;
          });

          const showMore = item.parentElement?.querySelector('li.show-more');

          showMore?.addEventListener('click', () => {
            showMore.classList.add('!hidden');
            item.parentElement.style.height = `${item.parentElement.scrollHeight}px`;
          });
        });

        navSubItemsMobileButtonLinks.forEach(buttonLinkListener);
      },
      expandContainer: () => {
        const navContainerDesktop = document.querySelector('#header-navigation-container');
        navContainerDesktop.style.height = `${navContainerDesktop.scrollHeight}px`;
        const activeMenu = document.querySelector('#header-navigation-desktop > ul > li.prev');
        activeMenu && activeMenu.classList.replace('prev', 'active');
      },
      collapseContainer: () => {
        const navContainerDesktop = document.querySelector('#header-navigation-container');
        navContainerDesktop.style.height = ``;
        const activeMenu = document.querySelector('#header-navigation-desktop > ul > li.active');
        activeMenu && activeMenu.classList.replace('active', 'prev');
      },
      goBack: () => {
        const navItemsContainerMobile = document.querySelector('#header-navigation-mobile > ul');
        navItemsContainerMobile?.classList.remove('!-left-full', 'opacity-0');
        const navItemsMobile = document.querySelectorAll('#header-navigation-mobile > ul > li');
        setTimeout(() => {
          navItemsMobile.forEach(item => item.classList.remove('active'));
          const menuItems = document.querySelectorAll('.header-navigation-menu');
          menuItems.forEach(item => {
            item.classList.add('!hidden');
            item.classList.remove('active');
          });
        }, 500);
      },
      openDrawer: () => {
        if (!Store.isMobile() || !Store.Header.elements.navigation) return;
        document.querySelector('body')?.classList.add('fixed', 'w-full');
        document.querySelector('.header')?.classList.add('h-screen', 'overflow-y-scroll');

        Store.Header.elements.navigation.classList.add('!left-0');
        Store.Header.elements.hamburger.classList.add('hidden');
        Store.Header.elements.membership.classList.add('hidden');
        Store.Header.elements.cart.classList.add('hidden');
        Store.Header.elements.close.classList.remove('hidden');
        Store.Header.elements.logo.classList.add('!ml-0');
        Store.isMobileMenuOpen = true;
      },
      closeDrawer: () => {
        if (!Store.isMobile() || !Store.Header.elements.navigation) return;
        document.querySelector('body')?.classList.remove('fixed');
        document.querySelector('.header')?.classList.remove('h-screen', 'w-full', 'overflow-y-scroll');
        Store.Header.elements.navigation.classList.remove('!left-0');
        Store.Header.elements.hamburger.classList.remove('hidden');
        Store.Header.elements.membership.classList.remove('hidden');
        Store.Header.elements.cart.classList.remove('hidden');
        Store.Header.elements.close.classList.add('hidden');
        Store.Header.elements.logo.classList.remove('!ml-0');
        Store.isMobileMenuOpen = false;
      },
      toggleAccountModal: event => {
        event.stopPropagation();
        const accountNavigationContainer = document.getElementById('account-navigation-container');

        const animationClassIn = 'animate-modal-pop-in';
        const animationClassOut = 'animate-modal-pop-out';

        let lastScrollTop = 0;
        let clickListenerAdded = false;

        function handleDocumentClick(e) {
          if (!accountNavigationContainer.contains(e.target)) {
            hideModal();
          }
        }

        function hideModalOnScroll() {
          if (window.scrollY > lastScrollTop) {
            hideModal();
          }
        }

        function showModal() {
          if (!clickListenerAdded) {
            document.addEventListener('click', handleDocumentClick);
            clickListenerAdded = true;
          }

          // Show modal
          accountNavigationContainer.classList.remove('hidden');

          // Reset and apply enter animation
          accountNavigationContainer.classList.remove(animationClassOut);
          void accountNavigationContainer.offsetWidth;
          accountNavigationContainer.classList.add(animationClassIn);

          // Set current scroll position
          lastScrollTop = window.scrollY || document.documentElement.scrollTop;

          // Attach scroll handler
          window.addEventListener('scroll', hideModalOnScroll);
        }

        function hideModal() {
          if (clickListenerAdded) {
            document.removeEventListener('click', handleDocumentClick);
            clickListenerAdded = false;
          }

          // Hide modal
          accountNavigationContainer.classList.remove(animationClassIn);
          accountNavigationContainer.classList.add(animationClassOut);

          setTimeout(() => {
            accountNavigationContainer.classList.add('hidden');
          }, 250); // match animation duration

          // Remove scroll handler
          window.removeEventListener('scroll', hideModalOnScroll);
        }

        if (accountNavigationContainer.classList.contains('hidden')) {
          showModal();
        } else {
          hideModal();
        }
      },
    },
    closeAnnouncementRibbon: () => {
      const announcementRibbon = document.querySelector('.announcement-ribbon');
      announcementRibbon?.parentElement?.remove();
    },
  },
  isMobileMenuOpen: false,
  Footer: {
    initAccordion: () => {
      const footerAccordionElements = document.querySelectorAll('.accordion');

      const closeAllAccordions = exceptElement => {
        footerAccordionElements.forEach(el => {
          if (el !== exceptElement && el.classList.contains('open')) {
            el.classList.remove('open');
            el.classList.add('close');

            const minusIcon = el.querySelector('.minus-icon');
            const plusIcon = el.querySelector('.plus-icon');
            const accordionContent = el.querySelector('.accordion-content');

            plusIcon.classList.remove('hidden');
            minusIcon.classList.add('hidden');
            accordionContent.classList.add('hidden');
          }
        });
      };

      footerAccordionElements.forEach(element => {
        element.addEventListener('click', event => {
          if (element.classList.contains('open')) {
            element.classList.remove('open');
            element.classList.add('close');

            const minusIcon = element.querySelector('.minus-icon');
            const plusIcon = element.querySelector('.plus-icon');
            const accordionContent = element.querySelector('.accordion-content');

            plusIcon.classList.remove('hidden');
            minusIcon.classList.add('hidden');
            accordionContent.classList.add('hidden');
            return;
          }

          closeAllAccordions(element);

          element.classList.add('open');
          element.classList.remove('close');

          const minusIcon = element.querySelector('.minus-icon');
          const plusIcon = element.querySelector('.plus-icon');
          const accordionContent = element.querySelector('.accordion-content');

          plusIcon.classList.add('hidden');
          minusIcon.classList.remove('hidden');
          accordionContent.classList.remove('hidden');
        });
      });
    },
  },
  Cart: {
    json: async () => {
      return await getCart();
    },
    resizeImage: function (image) {
      return image.replace('.jpg', '_240x240.jpg');
    },
    getCart: async function () {
      const data = await fetch('/cart.js');
      const json = await data.json();
      Store.Shared.Cart = json;
      document.querySelectorAll('.basket-total-count .indicator').forEach(indicator => {
        indicator.innerHTML = Store.Shared.Cart.item_count;
        indicator.classList.toggle('hidden', Store.Shared.Cart.item_count == 0);
      });

      return json;
    },
    updateCart: async function (url, type, quantity, id, properties = {}) {
      const cart = await this.getCart();
      const products = cart.items;
      const hasPreOrderProducts = products.some(
        product => product.properties && product.properties['_isPreOrder'] === true
      );
    
      const isPreOrder = properties && properties['_isPreOrder'] === true;

      if (
        url === 'add' &&
        ((hasPreOrderProducts && !isPreOrder) || (products.length && !hasPreOrderProducts && isPreOrder))
      ) {
        Store.toast(Store.Translations['cart.general.pre_order_multiple_products_error']);
        return null;
      }

      const product = await fetch(`/cart/${url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id,
          quantity: type === 'inc' ? (quantity = ++quantity) : type === 'dec' ? (quantity = --quantity) : quantity,
          properties,
        }),
      })
        .then(response => {
          if (!response.ok) {
            response.text().then(text => {
              const error = JSON.parse(text);
              //TODO: Missing error modal { error.description }
            });
          } else {
            return response.json();
          }
        })
        .then(async data => {
          const cart = await Store.Cart.getCart();
          const product = Store.Shared.Product && Store.Shared.Product.data;
          const variant = Store.Shared.Product && Store.Shared.Product.currentVariant;

          if (url === 'add') {
            Store.Emitter.emit(Store.Emitter.types.added_to_cart, {product, variant, quantity});
            if (typeof GA4Events != 'undefined' && product && variant) {
              GA4Events.on.added_to_cart(product, variant, quantity);
            }
          } else if (url === 'change' && quantity === 0) {
            Store.Emitter.emit(Store.Emitter.types.removed_from_cart, id);
            if (typeof GA4Events != 'undefined') {
              GA4Events.on.removed_from_cart(Store.Shared.Cart.items.find(item => item.id == id));
            }
          }
          return data;
        });
      return product;
    },
    removeFromCart: function (key) {
      this.updateCart('change', (type = false), 0, key);
    },
    addedToCart: (product, count) => {
      const modal = document.querySelector('.added-to-cart-modal');
      const template = modal.querySelector('.added-to-cart-product');
      let formattedPrice = (product.price / 100).toLocaleString(Shopify.locale, {
        style: 'currency',
        currency: Shopify.currency.active,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      template.querySelector('img').src = product.image;
      template.querySelector('h4').innerHTML = product.product_title;
      template.querySelector('span.variant').innerHTML = product.variant_title;
      template.querySelector('span.quantity').innerHTML = `${count}`;
      template.querySelector('span.product-text').innerHTML = Store.Translations['cart.label.product'];
      template.querySelector('span.price').innerHTML = formattedPrice;
      Store.Modal.show(modal);
    },
  },
  ReverseSpinner: {
    isLoadingFinished: false,
    setLoadingFinished: () => {
      const spinner = document.getElementById('reverse-spinner') | null;
      if (spinner) {
        spinner.style.display = 'none';
        Store.ReverseSpinner.isLoadingFinished = true;
      }
    },
  },
  Modal: {
    init: () => {
      const modalHandlers = document.querySelectorAll('[data-modal]');
      modalHandlers.forEach(handler => {
        handler.addEventListener('click', e => {
          const modal = document.querySelector(handler.dataset.modal);
          if (!modal) return;
          Store.Modal.open(handler, modal);
        });
      });

      const tooltipHandlers = document.querySelectorAll('[data-tooltip]');

      tooltipHandlers.forEach(handler => {
        ['mouseover', 'click'].forEach(function (e) {
          handler.addEventListener(e, () => {
            const tooltip = document.querySelector(handler.dataset.tooltip);
            if (!tooltip) return;
            Store.Modal.tooltip(handler, tooltip);
          });
        });
      });
    },
    //Refactor: use show hide fn
    open: (handler, modal) => {
      Store.isMobile() ? document.body.append(modal) : handler.append(modal);
      modal.classList.remove('invisible');
      modal.classList.add('opacity-100');
      Store.Shared.Modal = modal;

      if (Store.isMobile()) {
        modal.style.top = handler.offsetTop - modal.offsetHeight + 'px';
        const handlerRect = handler.getBoundingClientRect();
        const modalRect = modal.getBoundingClientRect();
        const h = handler.offsetWidth / 2;
        modal.style.setProperty('--after-left', handlerRect.left - modalRect.left + h - 8 + 'px');
      }

      const close = modal.querySelector('.close');
      const closeClickHandler = event => {
        if ((!modal.contains(event.target) && !handler.contains(event.target)) || close.contains(event.target)) {
          document.removeEventListener('click', closeClickHandler);
          Store.Modal.close();
        }
      };
      //Refactor: Use emitter
      document.addEventListener('click', closeClickHandler);
    },
    show: modal => {
      Store.Modal.overlay();
      setTimeout(() => {
        modal.classList.add('visible');
      }, 100);
    },
    hide: () => {
      Store.Modal.overlay();
    },
    close: () => {
      const modal = Store.Shared.Modal;
      modal.classList.add('invisible');
      modal.classList.remove('opacity-100');
      Store.Shared.Modal = {};
    },
    tooltip: (handler, tooltip) => {
      Store.isMobile() ? document.body.append(tooltip) : handler.append(tooltip);
      tooltip.classList.remove('invisible');
      tooltip.classList.add('opacity-100');
      Store.Shared.Tooltip = tooltip;

      if (Store.isMobile()) {
        tooltip.style.top = handler.offsetTop - tooltip.offsetHeight + 'px';
        const handlerRect = handler.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        const h = handler.offsetWidth / 2;
        tooltip.style.setProperty('--after-left', handlerRect.left - tooltipRect.left + h - 8 + 'px');
      }

      const closeMoveHandler = event => {
        handler.removeEventListener('mouseout', closeMoveHandler);
        tooltip.classList.add('invisible');
        tooltip.classList.remove('opacity-100');
        Store.Shared.Tooltip = {};
      };

      handler.addEventListener('mouseout', closeMoveHandler);
    },
    overlay: () => {
      const overlay = document.querySelector('.overlay');
      ['visible', 'hidden'].map(c => {
        overlay.classList.toggle(c);
      });

      overlay.querySelectorAll('.visible').forEach(modal => {
        modal.classList.remove('visible');
      });

      const isOpen = document.querySelector('.overlay.visible');

      if (isOpen) {
        const clickEmitterToken = Store.Emitter.subscribe('document.click', e => {
          if (overlay == e.target) {
            Store.Emitter.unsubscribe(overlay.dataset.token);
            overlay.dataset.token = '';
            Store.Modal.overlay();
          }
        });

        overlay.dataset.token = clickEmitterToken;
      } else {
        Store.Emitter.unsubscribe(overlay.dataset.token);
      }
    },
  },
  PDP: {
    init: () => {
      //Sticky Cart
      const scrollToken = Store.Emitter.subscribe('document.scroll', Store.PDP.toggleStickyCart);

      //Product Features
      const reorderCards = () => {
        // const features = document.querySelector('.product-features-card');
        // const information = document.querySelector('.product-information-wrapper');
        // const display = document.querySelector('.product-information-display');
        // Store.isMobile() ? information.append(features) : display.append(features);
      };

      const reorderToken = Store.Emitter.subscribe('window.resize', reorderCards);
      reorderCards();
      Store.PDP.insertExtendedContentToTab();

      //Tabs
      const tabs = document.querySelectorAll('nav.tabs > ul > li');
      tabs.forEach(item => {
        const nav = item.querySelector('nav');
        nav.addEventListener('click', e => {
          e.preventDefault();
          Store.Emitter.emit(Store.Emitter.types.pdp_tab_click, item);
        });
      });

      const tabClickToken = Store.Emitter.subscribe(Store.Emitter.types.pdp_tab_click, Store.PDP.tabClickHandler);

      Store.PDP.getBundledProducts();
      Store.PDP.bundleItemClickHandler();
      Store.PDP.scrollToBundledProducts();
      Store.PDP.renderFAQPanel();
      Store.PDP.generateFAQStructuredData();
    },
    insertExtendedContentToTab: () => {
      const content_blocks = document.querySelectorAll('[data-legacy-extended-section]');
      const container = document.querySelector('[data-legacy-extended-content-container]');
    
      if (container && content_blocks.length) {
        container.innerHTML = '';
        
        const contentWrapper = document.createElement('div');
        contentWrapper.className = 'extended-content-wrapper w-full';
        
        for (const content_block of content_blocks) {
          const clonedBlock = content_block.parentNode.cloneNode(true);
          
          const legacySection = clonedBlock.querySelector('[data-legacy-extended-section]');
          if (legacySection) {
            legacySection.style.display = 'block';
            legacySection.classList.remove('hidden');
          }
          
          contentWrapper.appendChild(clonedBlock);
        }

        container.appendChild(contentWrapper);
        
        // Force a reflow to ensure heights are calculated correctly
        setTimeout(() => {
          // Update the tab height if we're in a tab
          const activeTab = document.querySelector('nav.tabs > ul > li.active');
          if (activeTab) {
            const content = activeTab.querySelector('.tab-content-container');
            if (content) {
              activeTab.style.height = content.scrollHeight + 100 + 'px';
            }
          }
        }, 50);
      }
      if (container.querySelector('.product-comparison')) {
        const resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
            const tab = document.querySelector('nav.tabs > ul > li.active');
            if (tab) {
              const content = tab.querySelector('.tab-content-container');
              if (content) {
                tab.style.height = content.scrollHeight + 100 + 'px';
              }
            }
          }
        });
        
        resizeObserver.observe(container.querySelector('.product-comparison'));
      }

      const images = container.querySelectorAll('img');
      let imagesLoaded = 0;

      if (images.length > 0) {
        images.forEach(img => {
          if (img.complete) {
            imagesLoaded++;
            if (imagesLoaded === images.length) {
              updateTabHeight();
            }
          } else {
            img.addEventListener('load', () => {
              imagesLoaded++;
              if (imagesLoaded === images.length) {
                updateTabHeight();
              }
            });
          }
        });
      } else {
        updateTabHeight();
      }

      function updateTabHeight() {
        const tab = document.querySelector('nav.tabs > ul > li.active');
        if (tab) {
          const content = tab.querySelector('.tab-content-container');
          if (content) {
            tab.style.height = content.scrollHeight + 100 + 'px';
          }
        }
      }
    },
    variantDropdown: () => {
      const options = document.querySelector('.variant-options');
      const header = document.querySelector('.variant-header');
      const chevronDown = header.querySelector('.chevron-down');
      const chevronUp = header.querySelector('.chevron-up');
    
      header.classList.toggle('active');
      options.classList.toggle('hidden');
      
      // Toggle chevrons based on dropdown state
      const isOpen = header.classList.contains('active');
      chevronDown.classList.toggle('hidden', isOpen);
      chevronUp.classList.toggle('hidden', !isOpen);
    
      if (isOpen) {
        const closeDropdownHandler = event => {
          if (!header.contains(event.target)) {
            document.removeEventListener('click', closeDropdownHandler);
            header.classList.remove('active');
            options.classList.add('hidden');
            // Reset chevrons when closing
            chevronDown.classList.remove('hidden');
            chevronUp.classList.add('hidden');
          }
        };
        document.addEventListener('click', closeDropdownHandler);
      }
    },
    toggleStickyCart: async () => {
      const sticky = document.querySelector('.sticky-cart-wrapper');
      const CTA = document.querySelector('#add-to-cart-button');
      const isVisible = await Store.isElementInScrollView(CTA);
      if (isVisible) {
        sticky.classList.add('opacity-0');
        sticky.classList.remove('opacity-100');
      } else {
        sticky.classList.add('opacity-100');
        sticky.classList.remove('opacity-0');
      }
    },
    stickyCart: () => {
      const preview = document.querySelector('.sticky-preview');
      const cart = document.querySelector('.sticky-cart');
      const summary = document.querySelector('.sticky-summary');
      const chevron = document.querySelector('.sticky-cart-info img');

      preview.classList.add('hidden');
      cart.classList.remove('hidden');
      summary.classList.add('hidden');
      chevron.src = chevron.src.replace('down', 'up');
    },
    stickyPreview: () => {
      const preview = document.querySelector('.sticky-preview');
      preview.classList.toggle('hidden');
      const chevron = document.querySelector('.sticky-cart-info img');
      chevron.src = chevron.src.includes('down')
        ? chevron.src.replace('down', 'up')
        : chevron.src.replace('up', 'down');
    },
    stickySummary: () => {
      const preview = document.querySelector('.sticky-preview');
      const cart = document.querySelector('.sticky-cart');
      const summary = document.querySelector('.sticky-summary');
      preview.classList.add('hidden');
      cart.classList.add('hidden');
      summary.classList.remove('hidden');
      setTimeout(() => {
        Store.PDP.stickyCart();
      }, 3000);
    },
    createRelatedProductsLoader: () => {
      const loaderContainer = document.querySelector('#recommendations-loader');
      const numberOfCards = 4;
      if (!loaderContainer) return;
      for (let i = 0; i < numberOfCards; i++) {
        const loaderCardWrapper = document.createElement('div');
        loaderCardWrapper.className = 'flex flex-col';

        const loaderCard = document.createElement('div');
        loaderCard.className = 'animate-pulse w-[156px] h-[156px] lg:w-[264px] lg:h-[264px] bg-gray-50 rounded';

        loaderCardWrapper.appendChild(loaderCard);

        const titleLoader = document.createElement('div');
        titleLoader.className = 'h-3 bg-gray-50 rounded mt-3';
        titleLoader.style.width = '80%';
        loaderCardWrapper.appendChild(titleLoader);

        const descriptionLoader = document.createElement('div');
        descriptionLoader.className = 'h-3 bg-gray-50 rounded mt-2';
        descriptionLoader.style.width = '60%';
        loaderCardWrapper.appendChild(descriptionLoader);

        loaderContainer.appendChild(loaderCardWrapper);
      }

      return loaderContainer;
    },
    relatedProducts: async productId => {
      const recommendations = document.querySelector('#recommendations-slider');
      const loader = Store.PDP.createRelatedProductsLoader();
      if (recommendations) {
        loader.classList.remove('hidden');
        recommendations.classList.remove('hidden');
        const url = `/recommendations/products?section_id=product-recommendations&product_id=${productId}&limit=8`;
        const response = await fetch(url);
        const html = await response.text();
        loader.classList.add('hidden');
        recommendations.insertAdjacentHTML('afterBegin', html);
        recommendations.classList.remove('hidden');
        Store.Factory.productSlider('#recommendations-slider');
      }
    },
    increaseProductCount: () => {
      const input = document.querySelector('.stepper-input');
      //consider maximum stock value
      input.value = Number(input.value) + 1;
    },
    decreaseProductCount: () => {
      const input = document.querySelector('.stepper-input');
      input.value = input.value > 1 ? Number(input.value) - 1 : input.value;
    },
    addToCart: async (variantId, button = null, isPreOrder = false) => {
      button && (button.disabled = true);
      const count = Number(document.querySelector('.stepper-input:not(.recipe-products-stepper-input)')?.value || 1);
      const product = await Store.Cart.updateCart('add', false, count, variantId, {
        _isPreOrder : isPreOrder,
      });
      button && (button.disabled = false);
      product && Store.Cart.addedToCart(product, count);
      //Refactor: consider maximum stock value
    },
    features: () => {
      const features = document.querySelector('.product-features');
      const expander = document.querySelector('.product-features-expander');
      const button = expander.querySelector('a');
      const icon = button.querySelector('img');
      const isOpen = features.offsetHeight > 128;
      const featureCount = features.querySelectorAll('.feature').length;
      icon.src = isOpen ? icon.src.replace('up', 'down') : icon.src.replace('down', 'up');
      const height = Store.isMobile()
        ? `${Math.ceil(featureCount / 2) * 8 + 4}rem`
        : `${Math.ceil(featureCount / 3) * 8 + 3}rem`;
      features.style.height = isOpen ? '' : height;
    },
    tabs: () => {
      const tabs = document.querySelectorAll('nav.tabs > ul > li');
      const activeTabs = document.querySelectorAll('nav.tabs > ul > li.active');
      const activeTab = activeTabs[0];
      const firstTab = document.querySelector('nav.tabs > ul > li:first-child');

      // Desktop: Expand first tab alternating
      if (!Store.isMobile() && firstTab && !activeTab) firstTab.classList.add('active');

      // Desktop: Collapse expanded tabs from mobile
      if (!Store.isMobile() && activeTabs.length > 1)
        activeTabs.forEach((tab, index) => index > 0 && tab.classList.remove('active'));

      tabs.forEach(tab => {
        const content = tab.querySelector('.tab-content-container');
        tab.style.removeProperty('height');
        content && (content.style.height = '');
        !Store.isMobile() && tab.classList.contains('active') && (tab.style.height = content.scrollHeight + 100 + 'px');
        Store.isMobile() && tab.classList.contains('active') && (content.style.height = content.scrollHeight + 'px');
      });
    },
    tabClickHandler: item => {
      const activeTab = document.querySelector('nav.tabs > ul > li.active');
      if (activeTab === item) {
        item.classList.remove('active');
        Store.PDP.tabs();
        return;
      }
      // Desktop: Close active tab
      !Store.isMobile() && activeTab && activeTab.classList.remove('active');
      item.classList.toggle('active');
      Store.PDP.tabs();
    },
    renderBundleItem: async variantId => {
      const split = variantId.split('?');
      try {
        const element = document.querySelector(`.product-information-tabs`);
        const response = await fetch(`${split[0]}?section_id=pdp-detailed-information&bundle=1&${split[1]}`);
        const html = await response.text();
        element.innerHTML = html;
        const tabs = document.querySelectorAll('nav.tabs > ul > li');
        tabs.forEach(item => {
          const nav = item.querySelector('nav');
          nav.addEventListener('click', e => {
            e.preventDefault();
            Store.Emitter.emit(Store.Emitter.types.pdp_tab_click, item);
          });
        });
      } catch (err) {}
    },
    bundleItemClickHandler: async () => {
      const elements = document.querySelectorAll('.bundle-product-image-container');
      const loader = document.getElementById('extended-content-loader');

      if (elements.length) {
        const bundleImageContainers = Array.from(elements);

        bundleImageContainers.forEach(function (item) {
          item.addEventListener('click', async function (e) {
            e.preventDefault();
            const images = document.querySelectorAll('.bundle-product-image-container img');
            images.forEach(el => el.classList.remove('active'));
            item.querySelector('img').classList.add('active');
            const names = document.querySelectorAll('.bundle-product-name');
            names.forEach(el => el.classList.remove('selected'));
            item.parentElement.querySelector('.bundle-product-name').classList.add('selected');

            const variantId = item.getAttribute('href');
            if (variantId) {
              await Store.PDP.renderBundleItem(variantId);
              Store.PDP.tabs();
            }
          });
        });
      }
    },
    scrollToBundledProducts: () => {
      const bundledItemCta = document.querySelector('#go-to-bundled-pdcts-cta');
      if (bundledItemCta) {
        bundledItemCta.addEventListener('click', e => {
          e.preventDefault();
          const element = document.querySelector('#pdp-bundle-viewer');
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            });
          }
        });
      }
    },
    getBundledProducts: async () => {
      const element = document.getElementById('bundle-items');
      const parsedItems = element && JSON.parse(element.getAttribute('data-bundle-items'));

      if (!parsedItems) return;

      const sorted = parsedItems.sort((a, b) => a - b);
      const url = sorted.map(item => `variants.sku:${item}`).join('%20OR%20');

      const response = await fetch(`/search?type=product&q=${url}&view=product-api`);
      const data = await response.json();

      const filteredItems = [];
      const itemsToHide = [];

      for (const item of sorted) {
        const findItem = data.find(i => i.sku === item);
        if (findItem) {
          filteredItems.push(findItem);
        } else {
          itemsToHide.push(item);
        }
      }

      for (const item of itemsToHide) {
        const element = document.getElementById(`bundle-item-${item}`);
        element.parentElement.style.display = 'none';
      }

      const findSorted = filteredItems.find(item => item.sku === sorted[0]);

      if (findSorted) {
        const firstItem = document.getElementById(`bundle-item-${findSorted.sku}`);
        firstItem.querySelector('.bundle-product-image-container img').classList.add('active');
        firstItem.querySelector('.bundle-product-name').classList.add('selected');
      }

      for (const item of filteredItems) {
        const element = document.getElementById(`bundle-item-${item.sku}`);
        const link = element.querySelector('.bundle-product-image-container');
        link.setAttribute('href', item.handle);
        link.querySelector('img').setAttribute('src', item.image);
        element.querySelector('.bundle-product-name').innerHTML = item.title;
      }

      await Store.PDP.renderBundleItem(findSorted.handle);
    },
    generateFAQStructuredData: () => {
      const faqItems = document.querySelector('.faq-items');
      if (!faqItems) return;

      const faqItemsArray = Array.from(faqItems.querySelectorAll('.question-block'));
      const structuredData = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [],
      };

      for (const item of faqItemsArray) {
        const questionElement = item.querySelector('.question');
        const answerElement = item.querySelector('.answer');

        if (questionElement && answerElement) {
          const question = questionElement.textContent.trim();
          const answer = answerElement.textContent.trim();

          structuredData.mainEntity.push({
            '@type': 'Question',
            name: question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: answer,
            },
          });
        }
      }

      const structuredDataJSON = JSON.stringify(structuredData);
      const structuredDataScript = document.createElement('script');
      structuredDataScript.setAttribute('type', 'application/ld+json');
      structuredDataScript.textContent = structuredDataJSON;
      document.querySelector('head').appendChild(structuredDataScript);
    },
    renderFAQPanel: () => {
      const faqItems = document.querySelector('.faq-items');
      if (!faqItems) return;
    
      // Handle click event
      const handleBlockClick = event => {
        const block = event.target.closest('.question-block');
        if (!block) return;
    
        const answer = block.querySelector('.answer');
        const plusIcon = block.querySelector('.plus-icon');
        const minusIcon = block.querySelector('.minus-icon');
    
        if (!Store.isMobile()) {
          // Toggle answer visibility
          const isHidden = answer.classList.contains('lg:hidden');
          document.querySelectorAll('.answer').forEach(ans => {
            ans.classList.add('lg:hidden');
          });
          faqItems.querySelectorAll('.plus-icon').forEach(icon => {
            icon.style.display = 'inline';
          });
          faqItems.querySelectorAll('.minus-icon').forEach(icon => {
            icon.style.display = 'none';
          });
          if (isHidden) {
            answer.classList.remove('lg:hidden');
            plusIcon.style.display = 'none';
            minusIcon.style.display = 'inline';
          } else {
            answer.classList.add('lg:hidden');
            plusIcon.style.display = 'inline';
            minusIcon.style.display = 'none';
          }
    
          // Adjust tab height - IMPROVED HEIGHT CALCULATION
          const tab = document.querySelector('.tabs .active');
          if (tab) {
            const content = tab.querySelector('.tab-content-container');
            if (content) {
              // Allow time for the content to expand
              setTimeout(() => {
                tab.style.height = content.scrollHeight + 'px';
              }, 50);
            }
          }
        } else {
          // Adjust content height for mobile
          const tab = document.querySelector('.tabs .active');
          if (tab) {
            const content = tab.querySelector('.tab-content-container');
            if (content) {
              // Allow time for the content to expand
              setTimeout(() => {
                content.style.height = content.scrollHeight + 'px';
              }, 50);
            }
          }
          plusIcon.style.display = 'none';
          minusIcon.style.display = 'none';
        }
      };
    
      // Attach click event listener to faqItems container
      faqItems.addEventListener('click', handleBlockClick);
    }
    
  },
  Collection: {
    handle: undefined,
    query: undefined,
    currentPage: 0,
    startIndex: 0,
    sortBy: 'sales_amount',
    sortOrder: 'desc',
    itemsPerPage: 18,
    totalPageCount: 0,
    totalItems: 0,
    currentlyOpenDropdownId: null,
    isPillClicked: false,
    init: handle => {
      Store.Collection.getCollection(handle, true);
      document.addEventListener('click', e => {
        const openDropdown = document.querySelector('.dropdown.on');
        if (openDropdown && !openDropdown.contains(e.target)) {
          Store.Collection.currentlyOpenDropdownId = null;
          openDropdown.classList.remove('on');
        }
      });
    },
    getSelectedCategoryValuesFromUrl: category => {
      const queryParams = new URLSearchParams(window.location.search);
      const selectedValues = queryParams.getAll(`rb_${category}`);
      if (selectedValues.length > 0) {
        return selectedValues[0].split('|');
      }
      return [];
    },
    updateUrl: category => {
      const facets = Array.from(document.querySelectorAll('.dropdown-options .checkbox.active')).map(
        function (checkbox) {
          return {
            category: checkbox.getAttribute('data-category'),
            id: checkbox.getAttribute('data-id'),
          };
        }
      );

      const baseQueryString = window.location.search;
      const queryParams = new URLSearchParams(baseQueryString);
      queryParams.delete(`rb_${category}`);

      const groupedFacets = facets.reduce(function (acc, facet) {
        acc[facet.category] = acc[facet.category] || [];
        acc[facet.category].push(facet.id);
        return acc;
      }, {});

      Object.keys(groupedFacets).forEach(function (category) {
        const paramName = 'rb_' + category;
        const combinedValues = groupedFacets[category].join('|');
        queryParams.set(paramName, combinedValues);
      });

      // window.location.search = queryParams.toString();
      const newQueryString = queryParams.toString();

      // Set the new query string without reloading the page
      history.pushState({}, '', window.location.pathname + '?' + newQueryString);
    },
    clearAllQueryParams: () => {
      const queryParams = new URLSearchParams(window.location.search);
      const keys = [...queryParams.keys()];
      for (key of keys) {
        queryParams.delete(key);
      }
      // window.location.search = queryParams.toString();
      const newQueryString = queryParams.toString();

      // Set the new query string without reloading the page
      history.pushState({}, '', window.location.pathname + '?' + newQueryString);
    },
    clearQueryParam: category => {
      const baseQueryString = window.location.search;
      const queryParams = new URLSearchParams(baseQueryString);
      queryParams.delete(`rb_${category}`);
      const newQueryString = queryParams.toString();
      // Set the new query string without reloading the page
      history.pushState({}, '', window.location.pathname + '?' + newQueryString);
    },
    createStarRatingHTML: (rating, count, isActive, categoryAttribute) => {
      const disabled = count === 0;
      const starMappings = {
        fivestar: '&#9733;&#9733;&#9733;&#9733;&#9733;',
        fourstar: '&#9733;&#9733;&#9733;&#9733;&#9734;',
        threestar: '&#9733;&#9733;&#9733;&#9734;&#9734;',
        twostar: '&#9733;&#9733;&#9734;&#9734;&#9734;',
        onestar: '&#9733;&#9734;&#9734;&#9734;&#9734;',
        nostar: '&#9734;&#9734;&#9734;&#9734;&#9734;',
      };

      const starsHTML = starMappings[rating] || '';

      return `
      <div>
        <div class="checkbox ${disabled ? 'bg-gray-200' : ''} !flex !justify-center !items-center ${
          isActive ? 'active' : ''
        }" data-category="${categoryAttribute}" data-id="${rating}"></div>
        <span class="text-sm font-sans font-[350]">${starsHTML}</span>
        <div class="ml-auto font-sans font-semibold text-xs ${disabled ? 'text-gray-300' : ''}">${count}</div>
      </div>
    `;
    },
    createAndAppendListItem: (bucket, category, isActive, list, dropdown) => {
      const listItem = document.createElement('li');
      const disabled = bucket.count === 0;
      if (disabled) {
        listItem.classList.add('cursor-not-allowed', 'pointer-events-none');
      }

      listItem.addEventListener('click', () => {
        Store.Collection.facetClickHandler(category.attribute, bucket.value);
      });

      if (category.attribute === 'reviews_average_score_titles') {
        listItem.innerHTML = Store.Collection.createStarRatingHTML(
          bucket.value,
          bucket.count,
          isActive,
          category.attribute
        );
      } else {
        listItem.innerHTML = `
          <div>
            <div class="checkbox ${disabled ? 'bg-gray-200' : ''} !flex !justify-center !items-center ${
              isActive ? 'active' : ''
            }" data-category="${category.attribute}" data-id="${bucket.value}"></div>
            <span class="text-sm font-sans font-[350]">${bucket.value}</span>
            <div class="ml-auto font-sans font-semibold text-xs ${disabled ? 'text-gray-300' : ''}">${
              bucket.count
            }</div>
          </div>`;
      }

      list.appendChild(listItem);
    },

    createSelectedItemLabel: (dropdown, category) => {
      const selectedItems = dropdown.querySelector(`.selected-items`);
      const dropdownTitle = dropdown.querySelector(`.option`);
      if (selectedItems) selectedItems.remove();
      const selectedItemlabel = document.createElement('div');
      selectedItemlabel.classList.add('selected-items');

      const selectedCategoryItems = Store.Collection.getSelectedCategoryValuesFromUrl(category.attribute);
      if (selectedCategoryItems.length > 0) {
        const selectedItemsText = selectedCategoryItems.join(', ');
        selectedItemlabel.classList.add(
          'text-sm',
          'text-gray',
          'flex',
          'lg:hidden',
          'mt-1',
          'font-normal',
          'font-sans'
        );
        selectedItemlabel.innerText = selectedItemsText;
      }

      if (selectedCategoryItems.length > 0) {
        dropdownTitle.appendChild(selectedItemlabel);
      } else {
        selectedItemlabel.style.display = 'none';
      }
    },
    createSearchaniseFacets: searchaniseResponse => {
      const currentUrlParams = new URLSearchParams(window.location.search);
      const currentFilters = {};

      currentUrlParams.forEach((value, key) => {
        if (key.startsWith('rb_')) {
          const category = key.substring(3);
          currentFilters[category] = value.split('|');
        }
      });

      const filtersContainer = document.querySelector('#searchanise-facets');
      filtersContainer.innerHTML = '';
      const plusIconUrl = filtersContainer.getAttribute('data-plus-icon-url');
      const minusIconUrl = filtersContainer.getAttribute('data-minus-icon-url');

      const mobileFilterDropdown = document.createElement('div');
      mobileFilterDropdown.classList.add('filter-dropdown-mobile');

      mobileFilterDropdown.innerHTML =
        '<div class="dropdown-header md:flex-nowrap" data-id="mobile-filters"><span class="option">' +
        Store.Translations['collections.sorting.title_tags'] +
        '</span><i class="icon"></i></div>';

      mobileFilterDropdown.addEventListener('click', e => {
        Store.Searchanise.filters.toggleFilters('mobile-filters');
      });

      filtersContainer.appendChild(mobileFilterDropdown);

      let currentlyOpenDropdown = null;

      searchaniseResponse.facets.forEach(function (category) {
        if (category.attribute == 'price') return; //exclude price filter
        const filterDropdown = document.createElement('div');
        filterDropdown.className = 'filter-dropdown';

        const dropdown = document.createElement('div');
        dropdown.className = 'dropdown';
        dropdown.setAttribute('data-id', category.attribute);

        const dropdownHeader = document.createElement('div');
        dropdownHeader.classList.add('dropdown-header', 'md:flex-nowrap');
        const span = document.createElement('span');
        span.classList.add('option');
        span.innerText = category.title;

        const plusIcon = document.createElement('img');
        plusIcon.classList.add('h-6', 'w-6', 'plus-icon');
        plusIcon.src = plusIconUrl;

        const minusIcon = document.createElement('img');
        minusIcon.classList.add('h-6', 'w-6', 'hidden', 'minus-icon');
        minusIcon.src = minusIconUrl;

        if (Store.isMobile()) {
          dropdownHeader.appendChild(span);
          dropdownHeader.appendChild(plusIcon);
          dropdownHeader.appendChild(minusIcon);
        } else {
          dropdownHeader.innerHTML = '<span class="option">' + category.title + '</span><i class="icon"></i>';
        }
        dropdownHeader.addEventListener('click', e => {
          const isOpen = Store.Searchanise.filters.toggleDropdown(`${category.attribute}`);
          if (!isOpen) {
            if (currentlyOpenDropdown && currentlyOpenDropdown !== dropdownHeader) {
              const prevPlusIcon = currentlyOpenDropdown.querySelector('.plus-icon');
              const prevMinusIcon = currentlyOpenDropdown.querySelector('.minus-icon');
              if (prevPlusIcon && prevMinusIcon) {
                prevPlusIcon.classList.remove('hidden');
                prevMinusIcon.classList.add('hidden');
              }
            }
            currentlyOpenDropdown = dropdownHeader;
            plusIcon.classList.add('hidden');
            minusIcon.classList.remove('hidden');
          } else {
            plusIcon.classList.remove('hidden');
            minusIcon.classList.add('hidden');
            currentlyOpenDropdown = null;
          }
        });

        dropdown.appendChild(dropdownHeader);

        Store.Collection.createSelectedItemLabel(dropdown, category);

        const dropdownBody = document.createElement('div');
        dropdownBody.className = 'dropdown-body';

        const list = document.createElement('ul');
        list.className = 'dropdown-options';

        const maxItemsToDisplay = category.buckets.length === 6 ? 6 : 5;

        let visibleCount = Store.isMobile() ? category.buckets.length : maxItemsToDisplay;

        category.buckets.slice(0, visibleCount).forEach(function (bucket) {
          const isActive =
            currentFilters[category.attribute] && currentFilters[category.attribute].includes(bucket.value);
          Store.Collection.createAndAppendListItem(bucket, category, isActive, list, dropdown);
        });

        if (category.buckets.length > visibleCount) {
          const showMoreSpan = document.createElement('span');
          showMoreSpan.classList.add(
            'font-sans',
            'text-sm',
            'text-gray',
            'cursor-pointer',
            'underline',
            'hidden',
            'lg:flex',
            'px-6'
          );
          showMoreSpan.innerText = `${Store.Translations['collections.general.show_more']} (${
            category.buckets.length - visibleCount
          })`;

          showMoreSpan.addEventListener('click', () => {
            category.buckets.slice(visibleCount).forEach(function (bucket) {
              const isActive =
                currentFilters[category.attribute] && currentFilters[category.attribute].includes(bucket.value);
              Store.Collection.createAndAppendListItem(bucket, category, isActive, list);
            });
            list.classList.add('!h-80');
            showMoreSpan.classList.add('lg:hidden');

            const showLessSpan = document.createElement('span');
            showLessSpan.classList.add(
              'font-sans',
              'text-sm',
              'text-gray',
              'cursor-pointer',
              'underline',
              'hidden',
              'lg:flex',
              'px-6'
            );
            showLessSpan.innerText = Store.Translations['collections.general.show_less'];
            showLessSpan.classList.remove('lg:hidden');
            showLessSpan.addEventListener('click', () => {
              // Remove the extra buckets from the list
              while (list.children.length > visibleCount) {
                list.removeChild(list.lastChild);
              }

              // Hide the "Show Less" button and show the "Show More" button
              showLessSpan.classList.add('lg:hidden');
              showMoreSpan.classList.remove('lg:hidden');
              list.classList.remove('!h-80');
            });
            dropdownBody.appendChild(showLessSpan);
          });
          dropdownBody.appendChild(list);
          dropdownBody.appendChild(showMoreSpan);
        } else {
          dropdownBody.appendChild(list);
        }

        dropdown.appendChild(dropdownBody);

        filterDropdown.appendChild(dropdown);

        filtersContainer.appendChild(filterDropdown);
      });

      if (Store.isMobile()) {
        const dropdownButtons = document.createElement('div');
        dropdownButtons.classList.add(
          'dropdown-buttons',
          'filter-dropdown',
          'mt-20',
          '!px-6',
          'flex',
          'w-full',
          '!ml-0',
          'justify-between',
          'border-t',
          'border-gray-200',
          'py-6',
          '!fixed',
          'bottom-0',
          'left-0',
          'bg-white',
          'z-50'
        );

        const buttonApply = document.createElement('button');
        buttonApply.classList.add('button', 'btn-primary', 'w-auto');
        buttonApply.innerText = Store.Translations['general.search.apply'];

        buttonApply.addEventListener('click', e => {
          e.preventDefault();
          document.querySelector('.filter-dropdown-mobile').classList.toggle('on');
        });

        const buttonClear = document.createElement('button');
        buttonClear.classList.add('button', 'btn-text', 'w-auto', 'underline', '!pl-0');
        buttonClear.innerText = Store.Translations['general.search.clear'];

        buttonClear.addEventListener('click', e => {
          e.preventDefault();
          Store.Collection.clearAllQueryParams();
          document.querySelector('.filter-dropdown-mobile').classList.toggle('on');
          Store.Collection.getCollection(Store.Collection.handle);
        });

        dropdownButtons.appendChild(buttonClear);
        dropdownButtons.appendChild(buttonApply);
        filtersContainer.appendChild(dropdownButtons);
      }
    },
    createFacetsLoader: () => {
      const filtersContainer = document.querySelector('#searchanise-facets');
      if (!filtersContainer) return;

      filtersContainer.innerHTML = '';
      //Loader for filters/facets
      const filterLoader = document.createElement('div');
      filterLoader.className = 'bg-gray-50 h-6 rounded w-3/4 animate-pulse';
      filtersContainer.appendChild(filterLoader);
    },
    createProductsSkeleton: (isCollection = true) => {
      const container = document.querySelector('#collection-products');
      if (!container) return;

      container.innerHTML = '';

      // Loader for the collection products
      const loader = document.createElement('div');
      if(isCollection) {
        loader.className = 'mx-auto grid grid-cols-2 lg:grid-cols-3 gap-6';
      } else {
        loader.className = 'mx-auto grid grid-cols-2 lg:grid-cols-4 gap-6';
      }

      for (let i = 0; i < 12; i++) {
        const loaderCardWrapper = document.createElement('div');
        loaderCardWrapper.className = 'flex flex-col';

        const loaderCard = document.createElement('div');
        loaderCard.className = 'animate-pulse w-[156px] h-[156px] lg:w-[264px] lg:h-[264px] bg-gray-50 rounded';

        loaderCardWrapper.appendChild(loaderCard);

        const titleLoader = document.createElement('div');
        titleLoader.className = 'h-3 bg-gray-50 rounded mt-3';
        titleLoader.style.width = '80%';
        loaderCardWrapper.appendChild(titleLoader);

        const descriptionLoader = document.createElement('div');
        descriptionLoader.className = 'h-3 bg-gray-50 rounded mt-2';
        descriptionLoader.style.width = '60%';
        loaderCardWrapper.appendChild(descriptionLoader);

        loader.appendChild(loaderCardWrapper);
      }

      container.appendChild(loader);
    },

    createProductsUI: async (searchaniseResponse, filterParams, currentPage, sortBy, sortOrder) => {
      const products = searchaniseResponse.items.map(product => {
        return {sku: product.product_code, handle: product.link.split('/').pop()};
      });

      if (!products) return;

      const pages =
        searchaniseResponse.pages &&
        searchaniseResponse.pages.map(page => {
          return page;
        });

      var partialID = window.btoa(
        encodeURIComponent(
          `${Store.Collection.query}${currentPage}${sortBy}${sortOrder}${new URLSearchParams(filterParams).toString()}`
        )
      );

      const urlParams = new URLSearchParams(window.location.search);
      const tab = urlParams.has('tab') && urlParams.get('tab') == 'pages' ? 'pages' : 'products';
      const section = tab == 'pages' ? 'products-partial' : 'products-partial';

      const filtersContainer = document.querySelector('.collection-filters');
      if (tab == 'pages') {
        filtersContainer.style.display = 'none';

        //Recipes
        const currentPageRecipesHandles = pages
          .filter(o => o.link.includes('/kitchen/'))
          .map(article => article.link.replace('/blogs/', ''));

        const recipesResponse = await fetch(`/?section_id=recipes-listing-cards&recipes=${currentPageRecipesHandles}`);
        const recipesSection = await recipesResponse?.text();

        const container = document.querySelector('#collection-products');

        //Blogs
        const currentPageBlogsHandles = pages
          .filter(o => !o.link.includes('/kitchen/'))
          .map(article => article.link.replace('/blogs/', ''));

        const blogsResponse = await fetch(`/?section_id=blogs-listing-cards&blogs=${currentPageBlogsHandles}`);
        const blogsSection = await blogsResponse?.text();
        const divider = document.createElement('div');
        divider.classList.add('h-10');

        container.innerHTML =
          `<h3 class="font-semibold text-lg my-4">` +
          Store.Translations['general.search.recipes'] +
          `</h3>` +
          recipesSection +
          `<div class="h-10"></div><h3 class="font-semibold text-lg my-4">` +
          Store.Translations['general.search.blogs'] +
          `</h3>` +
          blogsSection;
      } else {
        var productsPartial = await fetch(
          `${window.location.pathname}/?sections=${section},${partialID}&products=${products.map(
            product => `${product.handle}:${product.sku}`
          )}`
        );

        const html = await productsPartial.json();
        document.querySelector('#collection-products').innerHTML = html['products-partial'];
      }
    },
    readAndLoadUrl: async handle => {
      const urlParams = new URLSearchParams(window.location.search);
      const h3Element = document.querySelector('.collection-body h3');
      Store.Collection.handle = handle;
      Store.Collection.query = handle;

      if (handle == 'search') {
        Store.Collection.query = urlParams.get('q');
        Store.Collection.sortBy = 'relevance';
        Store.Collection.sortOrder = 'desc';
        Store.Collection.itemsPerPage = 20;
        h3Element && (h3Element.style.opacity = 1);
        document.querySelector('.search-header h1').innerHTML = Store.Collection.query;
        document.querySelector('#collection-products').innerHTML = '';
        const h3TitleElement = h3Element && h3Element.querySelectorAll('span')[1];
        if (h3TitleElement)
          h3TitleElement.textContent = h3TitleElement.textContent.replace(/"([^"]*)"/, `"${Store.Collection.query}"`);
      }

      const {itemsPerPage} = Store.Collection;
      var currentPage, startIndex;

      if (urlParams.has('page')) {
        const parsedPage = parseInt(urlParams.get('page'));
        if (!isNaN(parsedPage) && parsedPage >= 0) {
          ({currentPage, startIndex} = Store.Collection = {
            ...Store.Collection,
            currentPage: parsedPage,
            startIndex: (parsedPage - 1) * itemsPerPage,
          });
        } else {
          window.location.href = window.location.href.split('?')[0];
        }
      } else {
        ({currentPage, startIndex} = Store.Collection = {
          ...Store.Collection,
          currentPage: 1,
          startIndex: 0,
        });
      }

      const {sortBy, sortOrder} = (Store.Collection = {
        ...Store.Collection,
        sortBy: urlParams.get('sort_by') || Store.Collection.sortBy,
        sortOrder: urlParams.get('sort_order') || Store.Collection.sortOrder,
      });

      const filterParams = {};
      urlParams.forEach((value, key) => {
        if (key.startsWith('rb_')) {
          const category = key.substring(3);
          filterParams[`rb_${category}`] = value.split('|');
        }
      });

      return {
        currentPage,
        startIndex,
        sortBy,
        sortOrder,
        filterParams,
        itemsPerPage,
        h3Element,
      };
    },
    createPagination: (currentPage, totalPageCount, totalItems, itemsPerPage) => {
      const newURL = new URL(window.location.href);
      const pagination = document.querySelector('#collection-pagination');
      const prevButton = document.querySelector('#prev-button');
      const nextButton = document.querySelector('#next-button');
      const mobilePager = document.querySelector('#mobile-pager');
      const pageNumbersContainer = document.querySelector('#page-numbers');

      // Reset pagination
      pageNumbersContainer.innerHTML = '';
      prevButton.classList.remove('hidden');
      nextButton.classList.remove('hidden');

      // Update Prev and Next buttons
      if (currentPage > 1) {
        newURL.searchParams.set('page', currentPage - 1);
        prevButton.querySelector('a').href = newURL.href;
      } else {
        prevButton.querySelector('a').href = 'javascript:;;';
        prevButton.classList.add('hidden');
      }

      if (currentPage < totalPageCount) {
        newURL.searchParams.set('page', currentPage + 1);
        nextButton.querySelector('a').href = newURL.href;
      } else {
        nextButton.querySelector('a').href = 'javascript:;;';
        nextButton.classList.add('hidden');
      }

      // Update mobile pager text
      mobilePager.textContent = mobilePager.textContent.replace('{0}', currentPage).replace('{1}', totalPageCount);

      const createPageLink = page => {
        const pageItem = document.createElement('li');
        const pageLink = document.createElement('a');
        pageLink.textContent = page;
        newURL.searchParams.set('page', page);
        pageLink.href = newURL.href;
        if (page === currentPage) pageItem.classList.add('active');
        pageItem.appendChild(pageLink);
        return pageItem;
      };

      const createEllipsis = () => {
        const ellipsis = document.createElement('li');
        ellipsis.textContent = '...';
        return ellipsis;
      };

      if (totalPageCount <= 7) {
        // If total pages are 7 or less, show all page numbers
        for (let i = 1; i <= totalPageCount; i++) {
          pageNumbersContainer.appendChild(createPageLink(i));
        }
      } else {
        pageNumbersContainer.appendChild(createPageLink(1));

        let startPage, endPage;
        if (currentPage <= 4) {
          startPage = 2;
          endPage = 5;
        } else if (currentPage >= totalPageCount - 3) {
          startPage = totalPageCount - 4;
          endPage = totalPageCount - 1;
        } else {
          startPage = currentPage - 2;
          endPage = currentPage + 2;
        }

        if (startPage > 2) {
          pageNumbersContainer.appendChild(createEllipsis());
        }
        for (let i = startPage; i <= endPage; i++) {
          pageNumbersContainer.appendChild(createPageLink(i));
        }

        if (endPage < totalPageCount - 1) {
          pageNumbersContainer.appendChild(createEllipsis());
        }

        if (endPage < totalPageCount) {
          pageNumbersContainer.appendChild(createPageLink(totalPageCount));
        }
      }

      if (totalItems > itemsPerPage) {
        pagination.classList.remove('hidden');
      } else {
        pagination.classList.add('hidden');
      }
    },
    fetchSelectedFacets: () => {
      const selectedFacets = Array.from(document.querySelectorAll('.dropdown-options .checkbox.active')).map(
        function (checkbox) {
          return {
            category: checkbox.getAttribute('data-category'),
            value: checkbox.getAttribute('data-id'),
          };
        }
      );
      return selectedFacets;
    },
    getCollection: async (handle, initialLoad = false) => {
      const openDropdownId = Store.Collection.currentlyOpenDropdownId;
      const {currentPage, startIndex, sortBy, sortOrder, filterParams, itemsPerPage, h3Element} =
        await Store.Collection.readAndLoadUrl(handle);

      const searchaniseResponse = await Store.Searchanise.getCollection(
        Store.Collection.handle,
        startIndex,
        itemsPerPage,
        sortBy,
        sortOrder,
        filterParams,
        initialLoad
      );

      Store.Collection.createSearchaniseFacets(searchaniseResponse);
      h3Element && (h3Element.style.opacity = 1);

      const {totalItems} = (Store.Collection.totalItems = {
        ...Store.Collection,
        totalItems: searchaniseResponse.totalItems,
      });

      if (!totalItems) {
        window.location.href = `/pages/empty-results-page?q=${handle}`;
        return;
      } else {
        document.querySelector('.content-for-layout').classList.remove('hidden');
      }

      const {totalPageCount} = (Store.Collection = {
        ...Store.Collection,
        totalPageCount: Math.ceil(totalItems / itemsPerPage),
      });

      const counter = document.querySelector('.collection-body #collection-size');
      counter && (counter.innerHTML = totalItems);

      const selectedFacets = Store.Collection.fetchSelectedFacets();

      Store.Collection.renderSelectedFacetPills(selectedFacets);

      Store.Collection.createPagination(currentPage, totalPageCount, totalItems, itemsPerPage);
      Store.Collection.createProductsUI(searchaniseResponse, filterParams, currentPage, sortBy, sortOrder);

      Store.Searchanise.filters.toggleDropdown(openDropdownId);

      if (openDropdownId) {
        const dropdown = document.querySelector(`[data-id=${openDropdownId}]`);

        if (Store.isMobile()) {
          document.querySelector('.filter-dropdown-mobile').classList.toggle('on');
          const minusIcon = dropdown.querySelector('.minus-icon');
          const plusIcon = dropdown.querySelector('.plus-icon');
          minusIcon.classList.remove('hidden');
          plusIcon.classList.add('hidden');
        }
      }
    },
    facetClickHandler: async (category, value) => {
      Store.Searchanise.filters.toggleCheckbox(category, value);
      Store.Collection.updateUrl(category);
      await Store.Collection.getCollection(Store.Collection.handle);
    },
    renderSelectedFacetPills: selectedFacetValues => {
      const collectionFiltersContainer = document.getElementById('collection-filters');
      const closeIconUrl = collectionFiltersContainer.getAttribute('data-close-icon-url');
      if (selectedFacetValues.length > 0) {
        collectionFiltersContainer.innerHTML = '';
        const hr = document.createElement('div');
        hr.classList.add('border-t', 'border-gray-200', 'my-5');
        collectionFiltersContainer.appendChild(hr);

        const outerContainer = document.createElement('div');
        outerContainer.classList.add('flex', 'justify-between', 'items-center');

        const selectedFacetsContainer = document.createElement('div');
        selectedFacetsContainer.classList.add(
          'flex',
          'flex-wrap',
          'gap-3',
          'collection-pills',
          'items-center',
          'w-full'
        );
        selectedFacetsContainer.id = 'collection-pills';

        selectedFacetsContainer.innerHTML = '';

        selectedFacetValues.forEach(facetValue => {
          const collectionPill = document.createElement('div');
          collectionPill.classList.add(
            'collection-pill',
            'bg-gray-50',
            'border',
            'border-gray-900',
            'px-4',
            'py-2',
            'h-8',
            'rounded-full',
            'flex',
            'justify-center',
            'items-center',
            'gap-3',
            'text-gray-900',
            'animate-fadeIn',
            'cursor-pointer'
          );

          const pillButton = document.createElement('button');
          pillButton.className = 'pill-close-btn !p-0 w-4 h-4 flex justify-center items-center';

          const pillCloseIcon = document.createElement('img');
          pillCloseIcon.src = closeIconUrl;
          pillCloseIcon.className = 'pill-close-icon !max-w-none';

          collectionPill.addEventListener('click', async () => {
            collectionPill.classList.remove('animate-fadeIn');
            collectionPill.classList.add('animate-fadeOut');
            collectionPill.addEventListener('animationend', () => {
              collectionPill.remove();
            });
            Store.Collection.isPillClicked = true;
            Store.Collection.clearQueryParam(facetValue.category);
            await Store.Collection.readAndLoadUrl(Store.Collection.handle);
            Store.Collection.facetClickHandler(facetValue.category, facetValue.value);
          });

          const pillText = document.createElement('span');
          pillText.className = 'font-semibold text-xs font-sans';
          pillText.textContent = facetValue.value;

          pillButton.appendChild(pillCloseIcon);
          collectionPill.appendChild(pillButton);
          collectionPill.appendChild(pillText);
          selectedFacetsContainer.appendChild(collectionPill);
        });

        outerContainer.appendChild(selectedFacetsContainer);
        const clearFiltersElement = document.createElement('div');
        clearFiltersElement.classList.add(
          'text-gray-900',
          'text-sm',
          'font-sans',
          'underline',
          'cursor-pointer',
          'font-semibold',
          'lg:ml-auto'
        );
        clearFiltersElement.textContent = Store.Translations['collections.sorting.clear_all_filters'];

        clearFiltersElement.addEventListener('click', async () => {
          Store.Collection.clearAllQueryParams();
          Store.Collection.isPillClicked = true;
          Store.Collection.getCollection(Store.Collection.handle);
          const pills = document.querySelectorAll('.collection-pill');
          pills.forEach(pill => {
            pill.classList.remove('animate-fadeIn');
            pill.classList.add('animate-fadeOut');
            pill.addEventListener('animationend', () => {
              pill.remove();
            });
          });
        });

        selectedFacetsContainer.appendChild(clearFiltersElement);
        collectionFiltersContainer.appendChild(outerContainer);
      } else {
        collectionFiltersContainer.innerHTML = '';
      }
    },
  },
  isElementInScrollView: async element => {
    return new Promise(resolve => {
      const observer = new IntersectionObserver((entries, observerItself) => {
        observerItself.disconnect();
        resolve(entries[0].intersectionRatio === 1);
      });
      observer.observe(element);
    });
  },
  backToTop: () => {
    const backToTopButton = document.getElementById('back-to-top-button');
    backToTopButton?.classList.add('hidden');
    let isButtonVisible = false;
    let lastScrollTop = 0;

    window.onscroll = function () {
      const scrolledDown = window.scrollY > lastScrollTop;
      const atTop = window.scrollY === 0;

      if (!scrolledDown && window.scrollY > 20 && !isButtonVisible) {
        backToTopButton?.classList.remove('hidden', 'animate-popOut');
        backToTopButton?.classList.add('animate-popIn');
        isButtonVisible = true;
      } else if ((scrolledDown || atTop) && isButtonVisible) {
        backToTopButton?.classList.remove('animate-popIn');
        backToTopButton?.classList.add('animate-popOut');

        backToTopButton?.addEventListener('animationend', function onHide() {
          backToTopButton.classList.add('hidden');
          backToTopButton.removeEventListener('animationend', onHide);
        });
        isButtonVisible = false;
      }

      lastScrollTop = window.scrollY;
    };

    backToTopButton?.addEventListener('click', function () {
      window.scrollTo({top: 0, behavior: 'smooth'});
    });
  },
  NewsLetter: {
    init: () => {
      Store.NewsLetter.markChecked();
      const newsLetterForm = document.getElementById('newsletter-form');
      newsLetterForm.addEventListener('submit', Store.NewsLetter.validateFormData);
      Store.NewsLetter.hideEmailErrorOnChange();
    },
    validateEmail: email => {
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailRegex.test(email);
    },

    buldFormData: (form, token) => {
      const formData = new FormData(form);
      const obj = {token};
      for (const [key, value] of formData.entries()) {
        if (value) {
          obj[key] = value;
        }
      }
      return obj;
    },
    markChecked: () => {
      const radioContainers = document.querySelectorAll('.radio-container');
      if (radioContainers) {
        radioContainers.forEach(radioContainer => {
          radioContainer.addEventListener('click', () => {
            const radio = radioContainer.querySelector('input[type="radio"]');

            const innerCheck = radioContainer.querySelector('.inner-check');

            if (!radio.checked) {
              const allRadiosInGroup = document.querySelectorAll(`input[type="radio"][name="${radio.name}"]`);

              allRadiosInGroup.forEach(otherRadio => {
                const otherInnerCheck = otherRadio.closest('.radio-container').querySelector('.inner-check');
                otherInnerCheck.classList.remove('checked-radio');
                otherRadio.removeAttribute('checked');
              });

              radio.setAttribute('checked', 'checked');
              innerCheck.classList.add('checked-radio');
            }
          });
        });
      }
    },
    scrollToTarget: selector => {
      const element = document.getElementById(selector);
      const offset = document.querySelector('.header').getBoundingClientRect().height;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    },
    submitFormData: async data => {
      const subscribeButton = document.getElementById('subscribe-button');
      subscribeButton.setAttribute('disabled', 'disabled');
      try {
        const token = await grecaptcha.execute(reCaptchaPublicKey, {action: 'newsletter_submit'});
        data.token = token;

        const response = await fetch('https://newsletter.nu3.tv/api/newsletter-subscription', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
          credentials: 'include',
        });

        subscribeButton.removeAttribute('disabled');

        if (response.ok) {
          document.getElementById('newsletter-form').classList.add('hidden');
          document.getElementById('form-info').classList.add('hidden');
          document.getElementById('success-message').classList.remove('hidden');
        } else {
          document.getElementById('process-error').classList.remove('hidden');
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    },
    showErrorField: selector => {
      const element = document.getElementById(selector);
      const emailField = document.getElementById('email-field');
      emailField.classList.add('!border-error-500');
      element.classList.remove('!hidden');
    },
    hideErrorField: selector => {
      const element = document.getElementById(selector);
      element.classList.add('!hidden');
      const emailField = document.getElementById('email-field');
      emailField.classList.remove('!border-error-500');
    },

    hideEmailErrorOnChange: () => {
      const emailField = document.getElementById('email-field');
      emailField.addEventListener('change', event => {
        const emailValue = event.target.value;
        if (Store.NewsLetter.validateEmail(emailValue)) {
          Store.NewsLetter.hideErrorField('email-field-error');
        }
      });
    },

    validateFormData: event => {
      event.preventDefault();
      const emailField = document.getElementById('email-field');
      const emailValue = emailField.value;
      document.getElementById('process-error').classList.add('hidden');
      if (Store.NewsLetter.validateEmail(emailValue)) {
        Store.NewsLetter.hideErrorField('email-field-error');
        const data = Store.NewsLetter.buldFormData(event.target);
        Store.NewsLetter.submitFormData(data);
      } else {
        Store.NewsLetter.showErrorField('email-field-error');
        Store.NewsLetter.scrollToTarget('newsletter-form');
      }
    },
  },
  bannerVideo: {
    init: (playIcon, pauseIcon, muteIcon, soundIcon) => {
      const videoContainer = document.querySelector('.banner-video');
      if (!videoContainer) {
        return;
      }
      const video = videoContainer.querySelector('#heroVideo');
      const playPauseBtn = videoContainer.querySelector('#playPauseBtn');
      const soundBtn = videoContainer.querySelector('#soundBtn');

      if (playPauseBtn) {
        playPauseBtn.addEventListener('click', () => {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
          updateButtonIcons();
        });
      }

      if (soundBtn) {
        soundBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          updateButtonIcons();
        });
      }

      updateButtonIcons();

      video.addEventListener('play', updateButtonIcons);
      video.addEventListener('pause', updateButtonIcons);

      function updateButtonIcons() {
        if (playPauseBtn) {
          playPauseBtn.innerHTML = video.paused ? playIcon : pauseIcon;
        }

        if (soundBtn) {
          soundBtn.innerHTML = video.muted ? muteIcon : soundIcon;
        }
      }
    },
  },
  toast: (message, icon) => {
    const isMobile = window.innerWidth <= 768 || Store.isMobile();

    const headerContainer = document.querySelector('.header-container');
    if (!headerContainer) return false;
    const headerRect = headerContainer.getBoundingClientRect();
    const toastOffsetX = window.innerWidth - headerRect.right;
    const isValidIcon = typeof icon === 'string' && icon.trim() !== ''; //&& /\.(jpg|jpeg|png|gif|svg|webp)$/i.test(icon);

    Toastify({
      text: message,
      avatar: isValidIcon ? icon : undefined,
      duration: 3000,
      close: false,
      gravity: 'top',
      position: isMobile ? 'center' : 'right',
      stopOnFocus: true,
      style: {
        background: '#fff',
        color: '#1F8D4A',
        fontSize: '14px',
        fontWeight: 'semi-bold',
        borderRadius: '8px',
        gap: '.5rem',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        alignItems: 'center',
      },
      offset: {
        x: isMobile ? undefined : toastOffsetX,
        y: 60,
      },
      onClick: function () {},
    }).showToast();
    return true;
  },
};

function invalidFormHandler(event) {
  event.preventDefault();
  const inputElem = event.target;

  changeInputErrorContentHandler(inputElem, false);
}

function formInputHandler(event) {
  const inputElem = event.target;

  changeInputErrorContentHandler(inputElem, true);
}

function changeInputErrorContentHandler(inputElem, isValid) {
  const errorElem = inputElem.closest('.form-field')?.querySelector('.form-field-error-text');

  inputElem.classList[isValid ? 'remove' : 'add']('form-field-input_invalid');
  if (errorElem) errorElem.textContent = isValid ? '' : inputElem.validationMessage;
}
